<template>
  <div id="galapagoshome">
    <div class="vx-row">

      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4 vs-align-center">
        <statistics-card-line icon="BookIcon" :statistic="stats.balanceCount" statisticTitle="Balanços cadastrados" type="area"></statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4 vs-align-center">
        <statistics-card-line vs-align-center icon="ShoppingBagIcon" :statistic="stats.companyCount" statisticTitle="Empresas cadastradas" color="warning" type="area"></statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
        <vs-card>
          <GenericChart id="score-chart-current-year" :values="stats.currrentYearChart"/>
        </vs-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4 vs-align-center">
        <vs-card>
          <GenericChart id="score-chart-last-year" :values="stats.lastYearChart"/>
        </vs-card>
      </div>

    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="mb-8" title="Busca">
          <!-- SEARCH BAR -->
          <vs-row>
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12" >
              <vs-row  vs-type="flex" >
                <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                  <span>Nome</span>
                  <vs-input
                    class="w-full d-theme-input-dark-bg"
                    v-model="name"
                    @keyup.enter="refine(cnpj, name)"
                    @keyup.esc="refine(cnpj, name)" />
                </vs-col>
                <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                  <span>Cnpj</span>
                  <CnpjInput
                    class="w-full d-theme-input-dark-bg"
                    v-model="cnpj"
                    @keyup.enter="refine(cnpj, name)"
                    @keyup.esc="refine(cnpj, name)" />
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="mt-4">
              <vs-row>
                <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="mt-1">
                  <vs-button class="w-full" @click="clearFilter()" icon-pack="fa" icon="fa-eraser" title="Limpar">
                    <span class="auto-hide-clear-text" >Limpar</span>
                  </vs-button>
                </vs-col>
                <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="mt-1">
                  <vs-button class="w-full" @click="refine(cnpj, name)" icon="search">Buscar</vs-button>
                </vs-col>
                <vs-col vs-lg="4" vs-sm="4" vs-xs="12" class="mt-1">
                  <vs-button class="w-full" @click="downloadExcel()">Exportar Excel</vs-button>
                </vs-col>
              </vs-row>
            </vs-col>

          </vs-row>

        </vx-card>
      </div>
    </div>


    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="cardx text-center greet-user" title="Lista de Score">

          <div id="data-list-list-view" class="data-list-container mt-4">

            <vs-table
              ref="table"
              stripe
              :data="companyList"
              noDataText="" >

              <template slot="thead">
                <th class="text-center">Nome</th>
                <th class="text-center">Cnpj</th>
                <th class="text-center">Cidade/UF</th>
                <th class="text-center">Balanço</th>
                <th class="text-center">Serasa</th>
                <th class="text-center">Compliance</th>
                <th class="text-center">Rating</th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <p class="font-medium">
                      <a style="cursor: pointer" @click="openCompany(tr.guid)">{{ tr.name }}</a>
                    </p>
                  </vs-td>

                  <vs-td>
                    <p>{{ (tr.cnpjAlfa || tr.cnpj) | formatCnpj }}</p>
                  </vs-td>

                  <vs-td>
                    <p>{{ tr.city }}</p>
                  </vs-td>

                  <vs-td>
                    <p>{{ tr.balance | formatDate }}</p>
                  </vs-td>

                  <vs-td>
                    <p>{{ tr.serasa }}</p>
                  </vs-td>

                  <vs-td>
                    <p>{{ tr.compliance }}</p>
                  </vs-td>

                  <vs-td>
                    <p>{{ tr.score }}</p>
                  </vs-td>

                </vs-tr>
                </tbody>
              </template>
            </vs-table>

            <div class="my-5">
              <vs-pagination
                v-model="page"
                :total="totalPages">
              </vs-pagination>
            </div>

          </div>

        </vx-card>
      </div>
    </div>

    <div
      class="content-area__heading border-0">
      <h2 class="mb-2">Últimos Score Calculados</h2>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/6 mb-base" v-for="(item, index) in stats.last10Scores" :key="index">
        <vx-card
          :title="item.name"
          title-color="#4e5156"
          class="bg-score-gradient">
          <h1 class="mb-6 mx-auto text-primary text-center"> Rating: {{ item.score }}</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5">Cnpj</p>
          <p class="font-semibold"> {{ (item.cnpjAlfa || item.cnpj) | formatCnpj }}</p>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5">Cidade</p>
          <p class="font-semibold"> {{ item.city }}</p>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5">Data do balanço</p>
          <p class="font-semibold"> {{ item.balance | formatDate }}</p>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueApexCharts from 'vue-apexcharts'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import axios from 'axios'
import CnpjInput from '@/components/CnpjInput'
import GenericChart from "@/components/stats/GenericChart";

export default {
  name: "GalapagosHome",
  components: {
    StatisticsCardLine,
    VueApexCharts,
    ChangeTimeDurationDropdown,
    VxTimeline,
    CnpjInput,
    GenericChart
  },
  data () {
    return {
      cnpj: null,
      name: null,
      companyList: [],
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
      page: 1,
      queriedItems: [],
      selected: null,
      stats: {
        companyCount: 0,
        balanceCount: 0,
        currrentYearChart: null,
        lastYearChart: null,
        last10Scores: [],
      },
    }
  },
  watch: {
    page () {
      this.scoreList()
    }
  },
  beforeMount() {
    this.getLastScores()
    this.scoreList()
  },
  methods: {
    getLastScores() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/home/score-stats`)
        .then((response) => {
          this.stats = response.data
        })
    },

    scoreList() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/home/score`,
        {
          params: {
            cnpj: this.cnpj,
            name: this.name,
            page: this.page - 1
          }
        }
      )
        .then((response) => {
          this.companyList = response.data.content
          this.totalPages = response.data.totalPages
        })
    },

    refine(cnpj, name) {
      this.cnpj = cnpj
      this.name = name
      this.page = 1
      this.scoreList()
    },

    clearFilter() {
      this.cnpj = null
      this.name = null
      this.page = 1
      this.scoreList()
    },

    openCompany(guid) {
      this.$router.push({path: `/balanco/${guid}`})
    },

    downloadExcel() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/home/score-stats/excel`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    }

  }
}
</script>

<style lang="scss">

</style>
